module.exports = function() {
  return new Worker(__webpack_public_path__ + "6d904134171f8116c1d5.worker.js");
};